export const environment = {
  production: true,
  groupName: "--",
  apiUrl: "https://ert-api.azure.chevron.com/api/v1",
  clientId: "d7ae916d-fdf5-4888-aeb4-50eb07a0a9a3",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
};
